import { CommonModule } from '@angular/common';
import { Component,OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCard, MatCardModule } from '@angular/material/card';
import { MatRipple } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { Signature } from '../models/signature.model';
import { MatIconModule } from '@angular/material/icon';



@Component({
  selector: 'app-signature',
  imports: [MatCardModule,MatExpansionModule,CommonModule,MatIconModule],
  templateUrl: './signature.component.html',
  styleUrl: './signature.component.css',
  standalone: true
  
})
export class SignatureComponent implements OnInit {


  
 signature: Signature[] =  [
  { id:1, type:'Starter' ,text : 'Mutton Kosha', image: 'assets/images/food1.jpeg', description: 'Mutton Kosha' ,stat:20, like:false },
  { id:2, type:'Starter', text: 'Kebabs', image: 'assets/images/food2.jpeg', description: 'Kebabs' ,stat:20 ,like:false },
  { id:3, type:'Starter',text: 'Desserts', image: 'assets/images/food3.jpeg', description: 'Desserts',stat:20 , like:false}
];

  constructor() { }

  ngOnInit(): void {
  }

 

  toggleLike(item:Signature) {
   const x= this.signature.findIndex(c=>c.id===item.id);
   this.signature[x].like=true;
  
  }


  shareContent(item:Signature) {
    if (navigator.share) {
      navigator.share({
        title: item.text,
        text: item.description,
        url: item.image
      }).then(() => {
        console.log('Successfully shared');
      }).catch((error) => {
        console.error('Something went wrong sharing the content', error);
      });
    } else {
      console.error('Web Share API is not supported in this browser');
    }
  }
}



 

